import { PropsWithChildren, forwardRef } from 'react';

import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonToolbar,
} from '@ionic/react';
import { useContextSelector } from 'use-context-selector';

import { ICONS_BASE64 } from '../../../Icon';
import { ActionSheetContext } from '../../ActionSheet.context';
import { ActionSheetMenuList } from '../ActionSheetMenuList/ActionSheetMenuList';
import { ActionSheetMenuContext } from '../ActionSheetMenu.context';

import styles from './ActionSheetMenuModal.module.scss';

type ActionSheetMenuModalProps = PropsWithChildren<{}>;

export const ActionSheetMenuModal = forwardRef<
  HTMLIonModalElement,
  ActionSheetMenuModalProps
>(({ children }, ref) => {
  const id = useContextSelector(ActionSheetContext, ({ id }) => id);

  const dismiss = useContextSelector(
    ActionSheetMenuContext,
    ({ dismiss }) => dismiss
  );

  return (
    <IonModal
      ref={ref}
      canDismiss
      trigger={id}
      handle={false}
      breakpoints={[0, 1]}
      initialBreakpoint={1}
      className={styles.root}
    >
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={dismiss} color="dark" shape="round">
              <IonIcon slot="icon-only" icon={ICONS_BASE64.x} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent />
      <div className={styles.content}>
        <ActionSheetMenuList>{children}</ActionSheetMenuList>
      </div>
    </IonModal>
  );
});
